import { clientEnv } from "../env";
import type { LessonPage, LessonState } from "../modules/teacher/teacher-state";
export interface LessonEnvelope { lesson: LessonState; durable: boolean; }
export class TeacherClientError extends Error {
  readonly status: number;
  constructor(status: number, message: string) { super(message); this.status = status; }
}
async function request(token: string, body?: unknown): Promise<LessonEnvelope> {
  const response = await fetch(`${clientEnv.apiBaseUrl}/teacher/lesson`, {
    method: body ? "PUT" : "GET",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    ...(body ? { body: JSON.stringify(body) } : {})
  });
  const payload = await response.json();
  if (!response.ok) throw new TeacherClientError(response.status, payload.error ?? "No se pudo guardar la lección.");
  if (!payload.lesson || !Array.isArray(payload.lesson.pages)) throw new Error("Lección no válida.");
  return payload as LessonEnvelope;
}
export function loadLesson(token: string): Promise<LessonEnvelope> { return request(token); }
export function saveLesson(token: string, input: {
  expectedVersion: number; requestId: string; page: LessonPage; summary: string; next: string;
}): Promise<LessonEnvelope> { return request(token, input); }
